import { render, staticRenderFns } from "./ContentButton.vue?vue&type=template&id=38e58533&scoped=true&"
import script from "./ContentButton.vue?vue&type=script&lang=js&"
export * from "./ContentButton.vue?vue&type=script&lang=js&"
import style0 from "./ContentButton.vue?vue&type=style&index=0&id=38e58533&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e58533",
  null
  
)

export default component.exports